export { default } from './components/text';
